export default __webpack_public_path__ + "static/media/1053.2dc8a421.svg";